import { JetView } from 'webix-jet';
import { devConfig, profile } from 'config/config';

/**
 * Class representing the filter history movement view.
 * @extends JetView
 */
export default class FilterHistoryMovementView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const left = {
            margin: 5,
            id: 'a1',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'text', // Text input for date selection
                            minWidth: 200,
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange',
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha de Creación'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                        },
                        {
                            view: 'datepicker', // Datepicker for selecting a date
                            name: 'Date',
                            id: 'Date',
                            stringResult: true,
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha de Creación'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: moment().format('YYYY-MM-DD'), // Default date value
                            format: '%d %M %Y',
                            suggest: {
                                type: 'calendar',
                                body: {
                                    maxDate: new Date(), // Limit to today's date
                                },
                            },
                        },
                        {
                            view: 'combo', // Combo box for movement type selection
                            name: 'Movement',
                            label: _('Movimiento'),
                            labelPosition: 'top',
                            minWidth: 200,
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: ' ', value: _('Todos') },
                                { id: '1', value: _('Entrada') },
                                { id: '2', value: _('Salida') },
                                { id: '3', value: _('Cancelación') },
                            ],
                            value: '',
                        },
                        {
                            view: 'combo', // Combo box for type selection
                            name: 'Type',
                            label: _('Tipo'),
                            labelPosition: 'top',
                            minWidth: 200,
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: ' ', value: _('Todos') },
                                { id: '10', value: _('Recargas') },
                                { id: '15', value: _('Ajuste de Saldo') },
                                { id: '20', value: _('Apuestas Deportivas') },
                                { id: '30', value: _('Apuestas Casino') },
                                { id: '40', value: _('Nota de retiro Creada') },
                                { id: '41', value: _('Nota de retiro Pagada') },
                                { id: '50', value: _('Bono Redimido') },
                                { id: '60', value: _('Aumento de cupo') },
                            ],
                            value: '',
                        },
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section containing filters
                },
            ],
        };
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Clear button
                    value: _('Limpiar'),
                    width: 100,
                    click: () => {
                        this.getRoot().clear(); // Clears the form
                    },
                },
                {
                    view: 'button', // Consult button
                    value: _('Consultar'),
                    hotkey: 'enter',
                    type: 'form',
                    width: 110,
                    id: 'consultDesk',
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove Date if typeDate is not 2
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove Datepicker if condition is true
                            }
                        }
                        this.app.callEvent('historyMovement:filter', [
                            filterdata, // Trigger filter event with data
                        ]);
                        $$('b5').collapse(); // Collapse the filter section
                        $$('a5').scrollTo(100, 0); // Scroll to a specific position
                    },
                },
            ],
        };
        const buttons2 = {
            padding: 10,
            cols: [
                {
                    view: 'button', // Clear button for second form
                    value: _('Limpiar'),
                    click: () => {
                        $$('myForm2').clear(); // Clears the second form
                    },
                },
                {
                    view: 'button', // Consult button for second form
                    value: _('Consultar'),
                    type: 'form',
                    click: () => {
                        const filterdata = $$('myForm2').getValues(); // Get values from second form
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove Date if typeDate is not 2
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove Datepicker if condition is true
                            }
                        }
                        this.app.callEvent('historyMovement:filter', [
                            filterdata, // Trigger filter event with data
                        ]);
                        $$('filterPopup').hide(); // Hide the filter popup
                    },
                },
            ],
        };
        const accordion_section2 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion for filters
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'),
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Upper section with filters and buttons
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section3 = {
            view: 'scrollview', // Scrollable view for filters
            scroll: 'xy',
            body: {
                padding: 10,
                rows: [upper_section], // Upper section with filters
            },
        };
        const filterPopup = webix.ui({
            view: 'window', // Popup window for filters
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' },
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Close the popup
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2',
                type: 'clean',
                rows: [accordion_section3, buttons2], // Accordion and buttons in the popup
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule
                },
            },
        });
        return {
            view: 'form',
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section2 // Show accordion if screen size is sufficient
                    : { height: 1, width: 0 },
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            if (profile.typeDate !== 2) {
                $$('Date').hide(); // Hide Date if typeDate is not 2
                $$('Datepicker').show(); // Show Datepicker
            } else {
                if (true) {
                    $$('Date').show(); // Show Date if condition is true
                    $$('Datepicker').hide(); // Hide Datepicker
                }
            }
        });
        const lang = this.app.getService('locale').getLang(); // Get current language
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal configuration
        });
    }
}

// FILE DOCUMENTED
